const ADD = 'add';
const REMOVE = 'remove';

export default Object.freeze({
    [ADD]: 0,
    [REMOVE]: 1,
});

export const BreakRuleActionNames = Object.freeze({
    0: ADD,
    1: REMOVE,
});
